import { render, staticRenderFns } from "./scorecard-order-standard.vue?vue&type=template&id=83651acc&scoped=true"
import script from "./scorecard-order-standard.vue?vue&type=script&lang=js"
export * from "./scorecard-order-standard.vue?vue&type=script&lang=js"
import style0 from "./scorecard-order-standard.vue?vue&type=style&index=0&id=83651acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83651acc",
  null
  
)

export default component.exports